//
// Mobile Functions
// --------------------------------------------------
// Checks browser height and returns a variable or class that can be targeted with css
// TODO: look into if this is working correctly or if this is required.

import { iOS, mobileCheck } from "./mobile-check";

window.addEventListener('load', event => {

    const closeNavResizeThrottle = _throttle(vhFix, 50, {leading: true, trailing: true});

    function vhFix(onLoad) {
        let windowHeight = window.innerHeight;
        let vh = windowHeight * 0.01;

        const checkHeight = setTimeout(() => {
            if (windowHeight !== window.innerHeight || onLoad === true) {
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }
            clearTimeout(checkHeight);
        }, 50);
    }

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    // Initialise vh fix on window load
    let onLoad = true;
    vhFix(onLoad);

    // Initialize resize listener to recalculate vh on resize
    window.addEventListener('resize', resizeListener);

    // Checks if any mobile device
    if (mobileCheck) {
        document.body.classList.add('mobile-device');
    }

    // Checks if device is ios / macos
    if (iOS) {
        document.body.classList.add('ios');
    }
});
